import { COUNTRY_CODES, countryLabel } from "../../utils/countryCodes";

/**
 * CountryCodeSelect — bundled dial-code dropdown (SPR-009 P2-5).
 *
 * Replaces the free-text country-code input on the Profile and Booking phone
 * fields. Options show flag + country name + dial code; the selected VALUE is
 * the E.164 dial code (e.g. "+1"), which is what the profile persists. Native
 * <select>, dependency-free.
 *
 * Several countries share a dial code (+1 = US/CA), so options are keyed by ISO
 * while the value remains the dial code; selecting any option sets the dial.
 *
 * @param {{
 *   label?: string,
 *   name: string,
 *   value: string,            // current dial code, e.g. "+1"
 *   onChange: (dial: string) => void,
 *   testId?: string,
 * }} props
 */
export default function CountryCodeSelect({
  label = "Country Code",
  name,
  value,
  onChange,
  testId,
}) {
  // Map the persisted dial back to a representative ISO for display. Falls back
  // to the dial itself so a non-listed value still round-trips.
  const selectedIso =
    COUNTRY_CODES.find((c) => c.dial === value)?.iso ?? "";

  const handleChange = (e) => {
    const iso = e.target.value;
    const country = COUNTRY_CODES.find((c) => c.iso === iso);
    onChange(country ? country.dial : "");
  };

  return (
    <div>
      {label && (
        <label
          htmlFor={name}
          className="block font-heading tracking-widest text-teal-deep text-sm mb-1"
        >
          {label}
        </label>
      )}
      <select
        id={name}
        name={name}
        value={selectedIso}
        onChange={handleChange}
        data-testid={testId ?? name}
        className="w-full border-2 border-charcoal rounded-xl px-3 py-2 font-body text-ink bg-white focus:outline-none focus:border-teal focus:ring-1 focus:ring-teal"
      >
        <option value="">Select…</option>
        {COUNTRY_CODES.map((c) => (
          <option key={c.iso} value={c.iso}>
            {countryLabel(c)}
          </option>
        ))}
      </select>
    </div>
  );
}
